import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 9"
    aria-hidden="true"
    role="img"
    fill="none"
  >
    <path d="M9.99972 1.06448C9.99972 1.56446 9.63305 1.9839 9.14975 2.09675V4.50002C9.14975 4.62906 9.03303 4.74191 8.8998 4.74191H5.24982V6.90318C5.73309 7.01614 6.09979 7.43545 6.09979 7.93545C6.09979 8.5161 5.61652 9 4.99977 9C4.38313 9 3.89974 8.53231 3.89974 7.93545C3.89974 7.43547 4.26641 7.01603 4.74971 6.90318L4.74994 4.74191H1.34996V6.90318C1.83323 7.01614 2.19993 7.43545 2.19993 7.93545C2.19993 8.5161 1.71666 9 1.0999 9C0.483271 9 0 8.53231 0 7.93556C0 7.43559 0.366664 7.01615 0.849965 6.9033V2.09682C0.366694 1.98386 0 1.56455 0 1.06455C0 0.483903 0.483271 0 1.10002 0C1.71666 0 2.20005 0.467687 2.20005 1.06455C2.20005 1.56453 1.83338 1.98397 1.35008 2.09682V4.25809H4.75006V2.09682C4.26679 1.98386 3.90009 1.56455 3.90009 1.06455C3.90009 0.483903 4.38337 0 5.00012 0C5.61675 0 6.10014 0.467687 6.10014 1.06455C6.10014 1.56453 5.73348 1.98397 5.25017 2.09682V4.25809H8.65015L8.65004 2.09682C8.16677 1.98386 7.80007 1.56455 7.80007 1.06455C7.80007 0.483903 8.28334 0 8.9001 0C9.51673 0.00011253 10 0.467802 10 1.06455L9.99972 1.06448Z" fill="currentColor" />
  </svg>
))``;
